import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MaterialUiListItem from '@material-ui/core/ListItem';
import MaterialUiListItemText from '@material-ui/core/ListItemText';
import { createStyles, Theme } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    }
});

/**
 * The properties this component can receive.
 */
interface ListItemAttributes {
    disabled?: boolean;
    button?: boolean;
    label?: string;
    onClick?: () => void;
}

/**
 * A wrapper function that renders a MaterialUi ListItem component.
 * @param props - The given property index signature object.
 * @returns A JSX React element.
 */
const ListItem = (props: ListItemAttributes) => {

    const ListItem = props.button ?
        (wrapper: any) => <MaterialUiListItem button disabled={props.disabled} onClick={props.onClick ? props.onClick : undefined}>{wrapper.children}</MaterialUiListItem> :
        (wrapper: any) => <MaterialUiListItem disabled={props.disabled} onClick={props.onClick ? props.onClick : undefined}>{wrapper.children}</MaterialUiListItem>

    return (
        <ListItem>
            {
                props.label &&
                <MaterialUiListItemText primary={props.label}/>
            }
        </ListItem>
    );
}

ListItem.muiName = 'ListItem';

export default withStyles(styles)(ListItem);